import type React from "react"
import { useEffect, useRef } from "react"
import { Card } from "react-bootstrap"
import * as echarts from "echarts";

// @ts-ignore
const LineChart: React.FC = ({ LineChartData, showLegend, showPercentYaxis }) => {
    const chartRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (!chartRef.current) return

        const chart = echarts.init(chartRef.current)

        const option = {
            title: {
                text: LineChartData?.title,
                textStyle: {
                    fontSize: 20,
                    fontWeight: 400,
                    color: "#18181B",
                    lineHeight: 16
                },
                left: 0,
                top: 0,
                subtext: LineChartData?.subtitle,
                subtextStyle: {
                    fontSize: 14,
                    color: "#838FB4",
                    fontWeight: 400,
                    lineHeight: 16
                }
            },
            tooltip: {
                trigger: "axis",
            },
            grid: {
                // left: "4%",
                // right: "4%",
                bottom: "15%",
                top: "20%",
                // containLabel: true,
            },
            xAxis: {
                type: "category",
                data: LineChartData?.xAxis?.categories,
                name: LineChartData?.xAxis?.name,
                nameLocation: "middle",
                nameGap: 30,
                nameTextStyle: {
                    color: "#18181B",
                    fontSize: 16,
                    fontWeight: 400
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#4B4B53",
                    fontWeight: 400,
                    rotate: 45,
                    formatter: function (value: string) {
                        const maxLength = 10;
                        return value.length > maxLength ? value.substring(0, maxLength) + '...' : value;
                    }
                },
            },
            yAxis: {
                type: "value",
                name: LineChartData?.yAxis?.name,
                nameLocation: "middle",
                // nameGap: 65,
                nameRotate: 90,
                nameTextStyle: {
                    color: "#18181B",
                    fontSize: 16,
                    fontWeight: 400
                },
                axisLabel: {
                    // formatter: showPercentYaxis ? "{value}%" : "{value}",
                    fontSize: 12,
                    color: "#4B4B53",
                    fontWeight: 400,
                    formatter: showPercentYaxis ?  "{value}%" : function (value:any) {
                        if (value >= 1000000000000) return (value / 1000000000000) + 'T';
                        if (value >= 1000000000) return (value / 1000000000) + 'B';
                        if (value >= 1000000) return (value / 1000000) + 'M';
                        if (value >= 1000) return (value / 1000) + 'K';
                        return value;
                      }
                },
                splitLine: {
                    lineStyle: {
                        type: "dashed",
                        color: "rgba(0, 102, 204, 0.25)"
                    }
                },
            },
            series: [
                {
                    name: LineChartData?.series[0]?.name,
                    type: "line",
                    symbol: "circle",
                    symbolSize: 8,
                    data: LineChartData?.series[0]?.data,
                    itemStyle: {
                        color: "#0066CC",
                    },
                },
            ],
        }

        chart.setOption(option)

        const handleResize = () => {
            chart.resize()
        }

        window.addEventListener("resize", handleResize)

        return () => {
            window.removeEventListener("resize", handleResize)
            chart.dispose()
        }
        //eslint-disable-next-line
    }, [LineChartData])

    return (
        <Card className="h-100 shadow-sm">
            <Card.Body className="p-3">
                <div ref={chartRef} style={{ width: "100%", height: "400px" }} />
            </Card.Body>
        </Card>
    )
}

export default LineChart;
